import {IPermission} from './database';
import {BaseModel} from './base.model';


export class Permission extends BaseModel<IPermission> implements IPermission {
  created_at: Date | null;
  deleted_at: Date | null;
  description: string | null;
  id: number;
  name: string;
  updated_at: Date | null;
  group: string;

}
